/**
 * Copyright 2025 SweetCode. All rights reserved.
 */

(function (pmw, $, undefined) {

	pmw.sendEventPayloadToServerPremium = async payload => {

		const isServerToServerEnabled = () => {

			if (pmwDataLayer?.general?.server_2_server?.active) return true

			return false
		}

		const isServerToServerDisabled = () => {
			return !isServerToServerEnabled()
		}

		const sendPayloadUsingFetch = payload => {

			// Send data to pmw public API with fetch API
			// https://caniuse.com/?search=fetch-keepalive
			fetch(pmw.root + "pmw/v1/sse/", {
				method     : "POST",
				credentials: "same-origin",
				headers    : {
					"Content-Type": "application/json",
				},
				body       : JSON.stringify(payload),
				keepalive  : true,	// keep connection alive until request is finished
				redirect: "error",
			})
				.then(response => response.json())
				.then(message => {
					message.success ? pmw.console.log(message) : pmw.console.error(message)
				})
				.catch(error => {
					pmw.console.error("sse error: ", error)
				})
		}

		const sendPayloadUsingNavigatorSendBeacon = data => {
			// https://css-tricks.com/send-an-http-request-on-page-exit/
			// https://caniuse.com/beacon
			const success = navigator.sendBeacon(pmw.root + "pmw/v1/sse/", data)

			success ? pmw.console.log("navigator.sendBeacon success") : pmw.console.error("navigator.sendBeacon failed")
		}

		const storeClientIpInServerSession = async (ip) => {

			pmw.console.log(`Storing client IP address in server session (${ip})`)

			jQuery.ajax({
				type    : "post",
				dataType: "json",
				url     : pmw.ajax_url,
				data    : {
					action: "pmw_store_client_ip_in_server_session",
					data  : {ip},
				},
				success : message => {
					pmw.console.log(message)
					pmw.storeData("store_client_ip_in_server_session", true)
				},
				error   : message => {
					pmw.console.error(message)
					pmw.storeData("store_client_ip_in_server_session", false)
				},
			})
		}

		try {
			// If server to server is disabled, do not send payload
			if (isServerToServerDisabled()) return

			// Check if the visitor is allowed (not a bot or on IP exclusion list)
			if (await pmw.isVisitorNotAllowed()) return

			// If Facebook CAPI is enabled, fetch and store the client IP address
			// Use the centralized getClientIp() which handles race conditions and validation
			if (pmwDataLayer?.pixels?.facebook?.capi) {
				// Use the promise-based IP detection to prevent race conditions
				const clientIp = await pmw.getClientIp()

				// If a WooCommerce session is active
				// and if we have not already sent the IP address to the server
				// and we have a valid client IP
				if (
					clientIp
					&& pmw.isInWooCommerceSesssion()
					&& !pmw.retrieveData("store_client_ip_in_server_session")
				) {
					await storeClientIpInServerSession(clientIp)
				}
			}

			pmw.console.log("Sending event to server", payload)

			if (await pmw.isRestEndpointAvailable()) { // Send data using REST API

				// console.log("Pixel Manager: Sending data using REST API")

				const blob = new Blob([JSON.stringify(payload)], {type: "application/json; charset=UTF-8"})

				// navigator.sendBeacon has a limit of 64kb and slightly better browser support (96% vs 95%).
				// Fall back to fetch with keepalive if the blob is too large.
				// https://caniuse.com/beacon vs https://caniuse.com/?search=fetch-keepalive
				if (blob.size < 60000) {
					sendPayloadUsingNavigatorSendBeacon(blob)
				} else {
					sendPayloadUsingFetch(payload)
				}
			} else { // Send data using wp-ajax

				jQuery.ajax({
					type    : "post",
					dataType: "json",
					url     : pmw.ajax_url,
					data    : {
						action: "pmw_server_to_server_event",
						data  : payload,
					},
					success : message => {
						pmw.console.log(message)
					},
					error   : message => {
						pmw.console.error(message)
					},
				})
			}

		} catch (e) {
			console.error(e)
		}
	}

	/**
	 * Sends transient session identifiers to the server.
	 *
	 * @param {object} payload
	 * @return {Promise<void>}
	 */
	pmw.sendTransientSessionIdentifiers = async payload => {

		try {
			jQuery.ajax({
				type    : "post",
				dataType: "json",
				url     : pmw.ajax_url,
				data    : {
					action: "pmw_process_transient_session_identifiers",
					data  : payload,
				},
				success : message => {
					pmw.console.log(message)
				},
				error   : message => {
					pmw.console.error(message)
				},
			})
		} catch (e) {
			console.error(e)
		}
	}

	pmw.acrRemoveCookie = () => {

		// Delete the pmw_checkout_order_created cookie
		// This cookie is used to verify that the purchase confirmation page has been reached

		pmw.deleteCookie("_pmw_automatic_conversion_recovery")
	}

	pmw.getAcrOrderDetails = async () => {

		// Get the order details from the _pmw_automatic_conversion_recovery cookie
		const acrOrderDetails = JSON.parse(pmw.getCookie("_pmw_automatic_conversion_recovery"))

		let response

		// Get order details from the server using the REST API if the REST API is available
		if (await pmw.isRestEndpointAvailable()) {
			response = await fetch(pmw.root + "pmw/v1/acr/order/", {
				method     : "POST",
				credentials: "same-origin",
				cache      : "no-cache",
				headers    : {
					"Content-Type": "application/json",
				},
				body       : JSON.stringify({
					order_id : acrOrderDetails.order_id,
					order_key: acrOrderDetails.order_key,
				}),
			})

		} else {
			// Get order details from the server using the wp-ajax API if the REST API is not available using jQuery
			response = await jQuery.ajax({
				type    : "POST",
				dataType: "json",
				url     : pmw.ajax_url,
				data    : {
					action: "get_acr_order_data_ajax",
					data  : {
						order_id : acrOrderDetails.order_id,
						order_key: acrOrderDetails.order_key,
					},
				},
			})

		}

		const responseJson = await response.json()

		if (responseJson.success) {
			pmw.console.log("ACR order details retrieved successfully")
		} else {
			pmw.console.log("ACR order details could not be retrieved", responseJson)
		}

		pmwDataLayer.products = {...pmwDataLayer.products, ...responseJson.data.products}
		pmwDataLayer.order    = responseJson.data.order
	}

}(window.pmw = window.pmw || {}, jQuery))
